import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../../Tabels/Tabels.css";
import plus from "../../../../Components/assets/icons/a1.png";
import colunms from "../../../../Components/assets/icons/LINES.png";
import search1 from "../../../../Components/assets/icons/search.png";
import top from "../../../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import Header from "../../../Header/Header";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import toast, { Toaster } from "react-hot-toast";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import ModalDelete from "../../../common/ModelDelete";
import ModelBulkUpload from "../../../common/ModelBulkUpload";
import { AddButton, EditButton, DeletButton } from "../../../common/Button";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { Button, Modal } from "react-bootstrap";
import OffcanvasCon from "../../../OffcanvasCon/OffcanvasCon";
import DataTable from "datatables.net";
import { formatDateTime, IDS, RoleId } from "../../../../utils/common";
import Pagination_Holder from "../../../common/Pagination_Holder/Pagination_Holder";
import Pagination from "react-bootstrap/Pagination";
import { useForm } from "react-hook-form";

library.add(fas);

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    Per_Page_Dropdown,
    postData,
    getDownloadDataExcel,
    isAllow,
    IMG_URL,
  } = useContext(Context);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [showSubscribe, setShowSubscribe] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [showoff, setShowoff] = useState(false);
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);

  const today = new Date().toISOString().split("T")[0]; // Format today as YYYY-MM-DD
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [errors1, setErrors1] = useState({});

  const [showWithdrawModal, setShowWithdrawModal] = useState(false);
  const [selectedBroker, setSelectedBroker] = useState(null);
  const [showWithdrawSuccessModal, setShowWithdrawSuccessModal] =
    useState(false);
  const [withdrawSuccessData, setWithdrawSuccessData] = useState(null);

  const [searchNumber, setsearchNumber] = useState("");
  const [searchEmail, setsearchEmail] = useState("");

  const {
    register,
    handleSubmit,
    reset: resetWithdrawForm,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      amount: "",
      account_no: "",
      ifsc_code: "",
      banking_name: "",
      branch_name: "",
    },
  });

  const handleWithdrawModal = (broker) => {
    setSelectedBroker(broker);
    resetWithdrawForm();
    setShowWithdrawModal(true);
  };

  const handleWithdraw = async (formData) => {
    const walletBalance = Number(selectedBroker?.amount || 0);
    const withdrawAmount = Number(formData.amount);

    if (walletBalance <= 0) {
      setError("amount", {
        type: "manual",
        message: "Wallet balance is ₹0.",
      });
      return;
    }

    if (withdrawAmount > walletBalance) {
      setError("amount", {
        type: "manual",
        message: "Withdraw amount cannot exceed wallet balance.",
      });
      return;
    }

    clearErrors("amount");

    const response = await postData("/admin/broker/wallet/withdraw", {
      wallet_id: selectedBroker.id,
      user_id: selectedBroker.user_id,
      ...formData,
    });

    if (response?.success) {
      // Store details before clearing selected broker
      setWithdrawSuccessData({
        brokerName: selectedBroker?.User?.name || "",
        amount: withdrawAmount,
        currentBalance: response?.data?.wallet?.current_balance,
      });

      // Close withdraw modal
      setShowWithdrawModal(false);

      // Reset form
      resetWithdrawForm();

      // Refresh wallet list
      await getDataAll();

      // Open success popup
      setShowWithdrawSuccessModal(true);
    }
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    validateDates(e.target.value, endDate);
  };

  // Handle End Date change
  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    validateDates(startDate, e.target.value);
  };

  // Validate Dates
  const validateDates = (start, end) => {
    let newErrors = {};
    const startDateObj = new Date(start);
    const endDateObj = new Date(end);

    // Validate Start Date
    if (start && startDateObj > new Date(today)) {
      newErrors.startDate = "Start date must be today or in the past";
    }

    // Validate End Date
    // if (end && endDateObj <= startDateObj) {
    //   newErrors.endDate = "End date must be greater than start date";
    // }

    setErrors1(newErrors);
  };
  const getDataAll = async () => {
    const response = await getData(
      `/admin/broker/wallet?page=${onPageChange}&per_page=${perPage}&term=${search}&contact_no=${searchNumber || ""}&email=${searchEmail || ""}&from=${startDate}&to=${endDate}`,
    );
    await setData(response);
    setCurrentPage(response?.data?.current_page);
    setperPage(response?.data?.per_page);
    // setSearch(response?.data?.search_name);
    settotalPages(response?.data?.total_pages);

    setOption(await Per_Page_Dropdown(response?.data?.total));
  };

  useEffect(() => {
    getDataAll();
  }, [changeStatus, perPage, reset, show, show1, onPageChange]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>,
    );
  }

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/admin/wallet/${id}`);
    setChangeStatus(response);
  };

  // Modal function
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(`/admin/wallet/${recordToDeleteId}`);
      // notify("error", "Deleted Succefully");

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
      setChangeStatus(response);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  //  column hide and show.....
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  useEffect(() => {
    const table = new DataTable("#example");
    return () => {
      table.destroy();
    };
  }, []);

  const [user, setUser] = useState({});
  const GetUser = async () => {
    const response = await getData(`/common/auth/usersingleget`);
    if (response?.success) {
      setUser(response?.data);
    }
  };
  useEffect(() => {
    GetUser();
  }, []);

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Partner Wallet"} link={"/admin/broker/wallet"} />
        <section className="AdvanceDashboard">
          <div className="col-lg-12 p-0">
            <div className="row MainRowsec me-0 ms-0">
              <section className="Tabels tab-radio tab-radio mt-3">
                <div className="">
                  {/* container */}
                  <div className="row">
                    {/* <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="border-line mt-3" />
                     

                      <div className="package-details-section-top-heading">
                        <div className="pending-table ">
                          <div className="d-flex  align-items-center">
                           

                            <div className="text-center  ms-5">
                              <Button onClick={() => setShowEdit(1)}>
                                + Add Money
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}

                    <div className="border-line mt-3"></div>

                    <div className="row mt-4">
                      <div className=" col-12">
                        <div className="d-flex align-items-center mb-3">
                          <div className="show me-2">
                            <p className="show m-0">Show</p>
                          </div>
                          <div className="number me-2">
                            <select
                              className="form-select form-select-sm"
                              aria-label=".form-select-sm example"
                              onChange={(e) => {
                                setonPageChange(1);
                                setperPage(e.target.value);
                              }}
                            >
                              {option?.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="entries">
                            <p className="show m-0">entries</p>
                          </div>
                          <div className="sowing ms-3 me-2">
                            <p className="show m-0">{`Showing ${Math.min(
                              (currentPage - 1) * perPage + 1,
                            )} to ${Math.min(
                              currentPage * perPage,
                              data?.data?.total,
                            )} of ${data?.data?.total} entries`}</p>
                          </div>
                        </div>
                        {/* </div>
                        <div className="   col-12"> */}

                        <div className="row align-items-end">
                          <div className="col-md-3 mt-2">
                            <div className="num">
                              <label className="form-label">Name</label>
                              <input
                                type="text"
                                className="form-control"
                                id=""
                                value={search}
                                placeholder="Search Name"
                                onChange={(e) => {
                                  setSearch(e.target.value);
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-md-3 mt-2">
                            <div className="num">
                              <label className="form-label">Email</label>
                              <input
                                type="text"
                                className="form-control"
                                id=""
                                value={searchEmail}
                                placeholder="Search Email"
                                onChange={(e) => {
                                  setsearchEmail(e.target.value);
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-md-3 mt-2">
                            <div className="num">
                              <label className="form-label">
                                Contact Number
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id=""
                                value={searchNumber}
                                placeholder="Contact Number"
                                onChange={(e) => {
                                  setsearchNumber(e.target.value);
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-12">
                            From
                            <div className="num">
                              <Form.Control
                                type="date"
                                placeholder="Start Date"
                                max={today}
                                value={startDate}
                                onKeyDown={(e) => e.preventDefault()}
                                onPaste={(e) => e.preventDefault()}
                                onChange={handleStartDateChange}
                                isInvalid={!!errors.startDate}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.startDate}
                              </Form.Control.Feedback>
                            </div>
                          </div>

                          {/* End Date */}
                          <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-12 mb-2 mt-2">
                            To
                            <div className="num">
                              <Form.Control
                                type="date"
                                placeholder="End Date"
                                min={startDate}
                                max={today}
                                value={endDate}
                                onKeyDown={(e) => e.preventDefault()}
                                onPaste={(e) => e.preventDefault()}
                                onChange={handleEndDateChange}
                                isInvalid={!!errors.endDate}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.endDate}
                              </Form.Control.Feedback>
                            </div>
                          </div>

                          <div className="col-xxl-1 col-xl-2  col-lg-2  col-md-2 col-12 mb-2 mt-2">
                            <div className="Search me-2">
                              <Button
                                type="button"
                                onClick={() => {
                                  setonPageChange(1);
                                  getDataAll();
                                }}
                                className="btn btn-search"
                              >
                                <img src={search1} className="search" alt="" />
                              </Button>
                            </div>
                          </div>
                          <div className="col-xxl-1 col-xl-2  col-lg-2  col-md-2 col-12 mb-2 mt-2">
                            <div className="Search-1">
                              <button
                                type="button"
                                onClick={() => {
                                  setSearch("");
                                  setsearchNumber("");
                                  setsearchEmail("");
                                  setStartDate("");
                                  setEndDate("");
                                  setReset(!reset);
                                }}
                                className="btn btn-reset"
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="border-line mt-3"></div>
                  <div className="row mt-3">
                    <div className="data table-responsive">
                      <Table striped bordered hover responsive center>
                        <thead>
                          <tr>
                            <th>Sr. No.</th>
                            <th>Created At</th>
                            <th>Partner Name</th>
                            <th>Email</th>
                            <th>Contact No.</th>
                            <th>Wallet Balance</th>
                            <th>Status</th>
                            {Number(user?.role_id) !== RoleId.Admin ? (
                              <th>Withdraw</th>
                            ) : (
                              <></>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {data?.data?.data?.map((d, index) => {
                            const sr = (onPageChange - 1) * perPage + index + 1;

                            return (
                              <tr key={d.id}>
                                <td>{sr}</td>
                                <td>{formatDateTime(d?.User?.createdAt)}</td>
                                <td>{d?.User?.name}</td>
                                <td>{d?.User?.email}</td>
                                <td>{d?.User?.contact_no}</td>
                                <td>₹ {Number(d?.amount).toFixed(2)}</td>

                                <td>
                                  {d?.User?.status ? (
                                    <span className="badge bg-success">
                                      Active
                                    </span>
                                  ) : (
                                    <span className="badge bg-danger">
                                      Inactive
                                    </span>
                                  )}
                                </td>

                                {Number(user?.role_id) !== RoleId.Admin ? (
                                  <td>
                                    <Button
                                      variant="success"
                                      size="sm"
                                      disabled={
                                        Number(user?.role_id) ===
                                          RoleId.Admin ||
                                        Number(d?.amount || 0) <= 0
                                      }
                                      onClick={() => handleWithdrawModal(d)}
                                    >
                                      Withdraw Amount
                                    </Button>
                                  </td>
                                ) : (
                                  <></>
                                )}
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                      {data && data?.data?.data?.length > 0 ? (
                        <Pagination_Holder
                          onPageChange={currentPage}
                          totalPages={totalPages}
                          handlePageChange={handlePageChange}
                        />
                      ) : (
                        <p className="no-datashow">Sorry, No Data Found</p>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}

      <ModalDelete
        show={showDeleteModal}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={handleDeleteCancel}
      />

      <ModelBulkUpload
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
      <Toaster position="top-right" />

      <OffcanvasCon show={showoff} handleClose={() => setShowoff(false)} />

      {/* Withdraw Amount Modal */}
      <Modal
        show={showWithdrawModal}
        onHide={() => {
          setShowWithdrawModal(false);
          resetWithdrawForm();
        }}
        centered
        backdrop="static"
      >
        <Form onSubmit={handleSubmit(handleWithdraw)}>
          <Modal.Header closeButton>
            <Modal.Title>Withdraw Amount</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Partner</Form.Label>
              <Form.Control value={selectedBroker?.User?.name || ""} disabled />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Wallet Balance</Form.Label>
              <Form.Control
                value={`₹ ${Number(selectedBroker?.amount).toFixed(2) || 0}`}
                disabled
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Withdraw Amount</Form.Label>

              <Form.Control
                type="text"
                inputMode="numeric"
                placeholder="Enter withdrawal amount"
                {...register("amount", {
                  required: "Amount is required",

                  validate: (value) => {
                    const amount = Number(value);
                    const walletAmount = Number(selectedBroker?.amount || 0);

                    if (amount <= 0) {
                      return "Amount must be greater than 0";
                    }

                    if (amount > walletAmount) {
                      return `Amount cannot exceed wallet balance of ₹${walletAmount}`;
                    }

                    return true;
                  },

                  onChange: (e) => {
                    e.target.value = e.target.value.replace(/\D/g, "");
                  },
                })}
              />

              <small className="text-danger">{errors.amount?.message}</small>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Account Number</Form.Label>
              <Form.Control
                type="text"
                inputMode="numeric"
                maxLength={18}
                placeholder="Enter bank account number"
                onKeyDown={(e) => {
                  // Allow only numbers and navigation keys
                  if (
                    !/[0-9]/.test(e.key) &&
                    ![
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ].includes(e.key)
                  ) {
                    e.preventDefault();
                  }
                }}
                {...register("account_no", {
                  required: "Account Number is required",

                  validate: (value) => {
                    if (!/^\d+$/.test(value)) {
                      return "Account Number must contain only numbers";
                    }

                    if (value.length < 9 || value.length > 18) {
                      return "Account Number must be between 9 and 18 digits";
                    }

                    return true;
                  },

                  onChange: (e) => {
                    // Remove anything other than numbers
                    e.target.value = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 18);
                  },
                })}
              />

              <small className="text-danger">
                {errors.account_no?.message}
              </small>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>IFSC Code</Form.Label>

              <Form.Control
                type="text"
                placeholder="e.g. SBIN0001234"
                maxLength={11}
                style={{ textTransform: "uppercase" }}
                {...register("ifsc_code", {
                  required: "IFSC Code is required",

                  validate: (value) => {
                    const ifsc = value.trim().toUpperCase();

                    if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc)) {
                      return "Enter a valid IFSC code (e.g. SBIN0001234)";
                    }

                    return true;
                  },

                  onChange: (e) => {
                    // Only allow letters and numbers
                    e.target.value = e.target.value
                      .replace(/[^a-zA-Z0-9]/g, "")
                      .toUpperCase()
                      .slice(0, 11);
                  },
                })}
              />

              <small className="text-danger">{errors.ifsc_code?.message}</small>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Bank Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter bank name"
                {...register("banking_name", {
                  required: "Bank Name is required",

                  maxLength: {
                    value: 100,
                    message: "Bank name cannot exced 100 characters",
                  },
                })}
              />
              <small className="text-danger">
                {errors.banking_name?.message}
              </small>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Branch Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Branch name"
                {...register("branch_name", {
                  required: "Branch Name is required",
                  maxLength: {
                    value: 100,
                    message: "Bank name cannot exced 100 characters",
                  },
                })}
              />
              <small className="text-danger">
                {errors.branch_name?.message}
              </small>
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowWithdrawModal(false);
                resetWithdrawForm();
              }}
            >
              Cancel
            </Button>

            <Button type="submit" variant="success">
              Withdraw
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* Success Pop up */}
      <Modal
        show={showWithdrawSuccessModal}
        onHide={() => {
          setShowWithdrawSuccessModal(false);
          setWithdrawSuccessData(null);
        }}
        centered
        backdrop="static"
        size="sm"
      >
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          <div
            className="d-flex align-items-center justify-content-center mx-auto mb-3"
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              background: "#198754",
              color: "#fff",
              fontSize: "30px",
              fontWeight: "bold",
            }}
          >
            ✓
          </div>

          <h5>Amount Withdrawn Successfully</h5>

          <p className="mb-1">
            Broker: <strong>{withdrawSuccessData?.brokerName}</strong>
          </p>

          <p className="mb-1">
            Withdraw Amount:{" "}
            <strong>₹ {Number(withdrawSuccessData?.amount).toFixed(2)}</strong>
          </p>

          {withdrawSuccessData?.currentBalance !== undefined && (
            <p className="mb-0">
              Current Balance:{" "}
              <strong>
                ₹ {Number(withdrawSuccessData?.currentBalance).toFixed(2)}
              </strong>
            </p>
          )}
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
          <Button
            variant="success"
            onClick={() => {
              setShowWithdrawSuccessModal(false);
              setWithdrawSuccessData(null);
            }}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Tables;
